import { render, staticRenderFns } from "./Notifications-Admin.vue?vue&type=template&id=7399c4d4&scoped=true"
import script from "./Notifications-Admin.js?vue&type=script&lang=js&external"
export * from "./Notifications-Admin.js?vue&type=script&lang=js&external"
import style0 from "./Notifications-Admin.vue?vue&type=style&index=0&id=7399c4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7399c4d4",
  null
  
)

export default component.exports